import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts('calendar', 'managed_practice_providers');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'provider',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['id'],
    },
    'calendar',
    'managed_practice_providers',
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/schedule/requests/practice-providers-req.js